
 class GameGraphicsLines extends SlotGame.src.component.GraphicsLinesComponent {
    protected SHADOW_ALPHA = 0.2;
    protected SHADOW_COLOR = 0x000000;
    protected SHADOW_LINE_WIDTH = 7;

    protected SHIFT_X = 190;

    protected LINE_WIDTH = 7;

    get colors() {
       return [
          0xFECB08
       ]
    }
}

//@ts-ignore
Game.src.component.GraphicsLinesComponent = GameGraphicsLines;

